import {useContext, useState} from 'react';
import {Button, Form, Input} from 'antd';
import {useLocation, useNavigate} from 'react-router-dom';
import {AuthContext} from 'context/Auth.context';
import SERVICES from 'services';
import Toast from 'components/Toast';
import {ltrim} from 'components/formItems/FormGroup/FormGroup';

const initialValues = undefined;
// process.env.NODE_ENV === 'development'
// 	? {
// 			email: 'davelantor12@gmail.com',
// 			password: '123321'
// 	  }
// 	: undefined;

interface InputErrorsTypes {
	email: string;
	password: string;
}

interface UserTypes {
	isSubmitting: boolean;
	inputErrors: InputErrorsTypes | null;
}

const Login = ({regIsOpen}: {regIsOpen: boolean}) => {
	const [user, setUser] = useState<UserTypes>({
		isSubmitting: false,
		inputErrors: null
	});
	const {dispatch} = useContext(AuthContext);
	const navigate = useNavigate();
	const location = useLocation() as any;

	let from = location.state?.from?.pathname || '/';

	const onFinish = (values: any) => {
		setUser({
			isSubmitting: true,
			inputErrors: null
		});
		SERVICES.AUTH.login(values)
			.then(res => {
				dispatch({
					type: 'LOGIN',
					payload: res.data
				});
				navigate(from, {replace: true});
			})
			.catch(err => {
				let errMessage = null;
				if (typeof err.message !== 'string') {
					errMessage = err.message;
				} else {
					Toast.error(err.message);
				}
				setUser({
					isSubmitting: false,
					inputErrors: errMessage
				});
			});
	};

	return (
		<div className="formContainer">
			<div className="formContainer_title">
				<span>Մուտք գործել</span>
				<div id="divider" />
			</div>
			<Form
				className="formContainer_form"
				layout="vertical"
				initialValues={initialValues}
				onFinish={onFinish}
				autoComplete="off">
				<Form.Item
					name="email"
					validateStatus={user.inputErrors?.email ? 'error' : undefined}
					getValueFromEvent={(val: any) => ltrim(val.target.value)}
					help={user.inputErrors?.email}
					rules={[{required: true, message: 'Մուտքագրեք Ձեր էլ․ հասցեն'}]}>
					<Input placeholder="Էլ․ փոստ" className="formContainer_form_input" />
				</Form.Item>

				<Form.Item
					name="password"
					validateStatus={user.inputErrors?.password ? 'error' : undefined}
					help={user.inputErrors?.password}
					rules={[{required: true, message: 'Մուտքագրեք Ձեր գաղտնաբառը'}]}>
					<Input.Password placeholder="Գաղտնաբառ" className="formContainer_form_input" />
				</Form.Item>

				<Form.Item style={{textAlign: 'center'}}>
					<Button
						className="formContainer_form_button"
						type="primary"
						htmlType="submit"
						loading={user.isSubmitting}>
						Մուտք
					</Button>
				</Form.Item>
			</Form>
			<div>
				{regIsOpen && (
					<div className="formContainer_footer">
						<span>Դեռևս գրանցված չե՞ք։</span>
						<a href="/register">Գրանցվել հիմա</a>
					</div>
				)}
				<div className="formContainer_footer">
					<span>Մոռացե՞լ եք գաղտնաբառը։</span>
					<a href="/forgot_password">Վերականգնել</a>
				</div>
			</div>
		</div>
	);
};

export default Login;
